import { defineComponent as y, inject as $, computed as m, ref as h, h as i } from "vue";
import { getTimeUnits as f, getAmPm as N, time as p } from "./ghl-ui.es1084.js";
import { timePickerInjectionKey as V } from "./ghl-ui.es1083.js";
import v from "./ghl-ui.es1348.js";
import b from "./ghl-ui.es959.js";
import P from "./ghl-ui.es242.js";
import g from "./ghl-ui.es1116.js";
const B = {
  actions: {
    type: Array,
    default: () => ["now", "confirm"]
  },
  showHour: {
    type: Boolean,
    default: !0
  },
  showMinute: {
    type: Boolean,
    default: !0
  },
  showSecond: {
    type: Boolean,
    default: !0
  },
  showPeriod: {
    type: Boolean,
    default: !0
  },
  isHourInvalid: Boolean,
  isMinuteInvalid: Boolean,
  isSecondInvalid: Boolean,
  isAmPmInvalid: Boolean,
  isValueInvalid: Boolean,
  hourValue: {
    type: Number,
    default: null
  },
  minuteValue: {
    type: Number,
    default: null
  },
  secondValue: {
    type: Number,
    default: null
  },
  amPmValue: {
    type: String,
    default: null
  },
  isHourDisabled: Function,
  isMinuteDisabled: Function,
  isSecondDisabled: Function,
  onHourClick: {
    type: Function,
    required: !0
  },
  onMinuteClick: {
    type: Function,
    required: !0
  },
  onSecondClick: {
    type: Function,
    required: !0
  },
  onAmPmClick: {
    type: Function,
    required: !0
  },
  onNowClick: Function,
  clearText: String,
  nowText: String,
  confirmText: String,
  transitionDisabled: Boolean,
  onClearClick: Function,
  onConfirmClick: Function,
  onFocusin: Function,
  onFocusout: Function,
  onFocusDetectorFocus: Function,
  onKeydown: Function,
  hours: [Number, Array],
  minutes: [Number, Array],
  seconds: [Number, Array],
  use12Hours: Boolean
}, A = y({
  name: "TimePickerPanel",
  props: B,
  setup(n) {
    const {
      mergedThemeRef: u,
      mergedClsPrefixRef: c
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    } = $(V), d = m(() => {
      const {
        isHourDisabled: t,
        hours: s,
        use12Hours: o,
        amPmValue: r
      } = n;
      if (o) {
        const a = r ?? N(Date.now());
        return f(p.hours, s, a).map((C) => {
          const k = Number(C), S = a === "pm" && k !== 12 ? k + 12 : k;
          return {
            label: C,
            value: S,
            disabled: t ? t(S) : !1
          };
        });
      } else
        return f(p.hours, s).map((a) => ({
          label: a,
          value: Number(a),
          disabled: t ? t(Number(a)) : !1
        }));
    }), e = m(() => {
      const {
        isMinuteDisabled: t,
        minutes: s
      } = n;
      return f(p.minutes, s).map((o) => ({
        label: o,
        value: Number(o),
        disabled: t ? t(Number(o), n.hourValue) : !1
      }));
    }), l = m(() => {
      const {
        isSecondDisabled: t,
        seconds: s
      } = n;
      return f(p.seconds, s).map((o) => ({
        label: o,
        value: Number(o),
        disabled: t ? t(Number(o), n.minuteValue, n.hourValue) : !1
      }));
    }), F = m(() => {
      const {
        isHourDisabled: t
      } = n;
      let s = !0, o = !0;
      for (let r = 0; r < 12; ++r)
        if (!(t != null && t(r))) {
          s = !1;
          break;
        }
      for (let r = 12; r < 24; ++r)
        if (!(t != null && t(r))) {
          o = !1;
          break;
        }
      return [{
        label: "AM",
        value: "am",
        disabled: s
      }, {
        label: "PM",
        value: "pm",
        disabled: o
      }];
    });
    return {
      mergedTheme: u,
      mergedClsPrefix: c,
      hours: d,
      minutes: e,
      seconds: l,
      amPm: F,
      hourScrollRef: h(null),
      minuteScrollRef: h(null),
      secondScrollRef: h(null),
      amPmScrollRef: h(null)
    };
  },
  render() {
    var n, u, c, d;
    const {
      mergedClsPrefix: e,
      mergedTheme: l
    } = this;
    return i("div", {
      tabindex: 0,
      class: `${e}-time-picker-panel`,
      onFocusin: this.onFocusin,
      onFocusout: this.onFocusout,
      onKeydown: this.onKeydown
    }, i("div", {
      class: `${e}-time-picker-cols`
    }, this.showHour ? i("div", {
      class: [`${e}-time-picker-col`, this.isHourInvalid && `${e}-time-picker-col--invalid`, this.transitionDisabled && `${e}-time-picker-col--transition-disabled`]
    }, i(b, {
      ref: "hourScrollRef",
      theme: l.peers.Scrollbar,
      themeOverrides: l.peerOverrides.Scrollbar
    }, {
      default: () => [i(v, {
        clsPrefix: e,
        data: this.hours,
        activeValue: this.hourValue,
        onItemClick: this.onHourClick
      }), i("div", {
        class: `${e}-time-picker-col__padding`
      })]
    })) : null, this.showMinute ? i("div", {
      class: [`${e}-time-picker-col`, this.transitionDisabled && `${e}-time-picker-col--transition-disabled`, this.isMinuteInvalid && `${e}-time-picker-col--invalid`]
    }, i(b, {
      ref: "minuteScrollRef",
      theme: l.peers.Scrollbar,
      themeOverrides: l.peerOverrides.Scrollbar
    }, {
      default: () => [i(v, {
        clsPrefix: e,
        data: this.minutes,
        activeValue: this.minuteValue,
        onItemClick: this.onMinuteClick
      }), i("div", {
        class: `${e}-time-picker-col__padding`
      })]
    })) : null, this.showSecond ? i("div", {
      class: [`${e}-time-picker-col`, this.isSecondInvalid && `${e}-time-picker-col--invalid`, this.transitionDisabled && `${e}-time-picker-col--transition-disabled`]
    }, i(b, {
      ref: "secondScrollRef",
      theme: l.peers.Scrollbar,
      themeOverrides: l.peerOverrides.Scrollbar
    }, {
      default: () => [i(v, {
        clsPrefix: e,
        data: this.seconds,
        activeValue: this.secondValue,
        onItemClick: this.onSecondClick
      }), i("div", {
        class: `${e}-time-picker-col__padding`
      })]
    })) : null, this.use12Hours ? i("div", {
      class: [`${e}-time-picker-col`, this.isAmPmInvalid && `${e}-time-picker-col--invalid`, this.transitionDisabled && `${e}-time-picker-col--transition-disabled`]
    }, i(b, {
      ref: "amPmScrollRef",
      theme: l.peers.Scrollbar,
      themeOverrides: l.peerOverrides.Scrollbar
    }, {
      default: () => [i(v, {
        clsPrefix: e,
        data: this.amPm,
        activeValue: this.amPmValue,
        onItemClick: this.onAmPmClick
      }), i("div", {
        class: `${e}-time-picker-col__padding`
      })]
    })) : null), !((n = this.actions) === null || n === void 0) && n.length ? i("div", {
      class: `${e}-time-picker-actions`
    }, !((u = this.actions) === null || u === void 0) && u.includes("clear") ? i(P, {
      theme: l.peers.Button,
      themeOverrides: l.peerOverrides.Button,
      size: "tiny",
      onClick: this.onClearClick
    }, {
      default: () => this.clearText
    }) : null, !((c = this.actions) === null || c === void 0) && c.includes("now") ? i(P, {
      size: "tiny",
      theme: l.peers.Button,
      themeOverrides: l.peerOverrides.Button,
      onClick: this.onNowClick
    }, {
      default: () => this.nowText
    }) : null, !((d = this.actions) === null || d === void 0) && d.includes("confirm") ? i(P, {
      size: "tiny",
      type: "primary",
      class: `${e}-time-picker-actions__confirm`,
      theme: l.peers.Button,
      themeOverrides: l.peerOverrides.Button,
      disabled: this.isValueInvalid,
      onClick: this.onConfirmClick
    }, {
      default: () => this.confirmText
    }) : null) : null, i(g, {
      onFocus: this.onFocusDetectorFocus
    }));
  }
});
export {
  A as default
};
